import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import styles from './PromosTable.module.css';
import { Table, Popconfirm, Icon, Checkbox } from 'antd';
import PromoProductsTable from 'components/Promo/PromoProductsTable';
import DOMPurify from 'dompurify/dist/purify.min.js';

const { Column } = Table;

export const PromosTable = (props) => {
  const {
    promos,
    loading,
    deletePromoduct,
    fetchPromo,
    promoType,
    searchProductKeyword,
    highlightedItems,
    onChangeHighlightedItems,
    isAbleToHideItemHasNoProduct,
  } = props;

  const [state, setState] = useState({
    promos: promos,
  });

  useEffect(() => {
    const filteredPromos = promos
      .map((pro) => {
        return {
          ...pro,
          type: pro.start_date && pro.end_date ? 'Promotion' : 'News',
          products: pro.product_ids
            .map((id) => props.products.find((p) => p.id === id))
            .filter((p) => {
              if (!p) {
                return false;
              }
              if (searchProductKeyword) {
                return p.title.toLowerCase().includes(searchProductKeyword.toLowerCase());
              }
              return true;
            }),
        };
      })
      .filter((promo) => {
        return promoType === 'all' ? true : promo.type.toLowerCase() === promoType;
      })
      .filter((promo) => (isAbleToHideItemHasNoProduct ? promo.products.length > 0 : true));
    // .filter(promo => {
    //   if (promo.type.toLowerCase() === 'news') {
    //     return true;
    //   }
    //
    //   const now = moment();
    //
    //   const startDate = moment.unix(promo.start_date);
    //   const endDate = moment.unix(promo.end_date);
    //   return now.isBetween(startDate, endDate) || now.isBefore(startDate);
    // });

    setState((prev) => ({
      ...prev,
      promos: filteredPromos,
    }));
  }, [promos, promoType, props.products, searchProductKeyword, isAbleToHideItemHasNoProduct]);

  const renderActions = (row) => {
    const { handleEdit, handleDelete, handleUploadOpen, handleNotify } = props;

    return (
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
        <li>
          <a onClick={() => handleEdit(row.id)}>Edit</a>
        </li>
        <li>
          <Popconfirm title="Delete this promotion?" onConfirm={() => handleDelete(row.id)}>
            <a>Delete</a>
          </Popconfirm>
        </li>
        <li>
          <a onClick={() => handleUploadOpen(row.id)}>Upload</a>
        </li>
        {checkPromoValidDate(row.end_date) ? (
          <li>
            {row['notif_count'] >= 1 ? (
              <Popconfirm
                placement="left"
                title={`Are you sure? You have already notified: ${row['notif_count']} time(s)`}
                onConfirm={() => handleNotify(row.id)}
              >
                <a>
                  <Icon type="rocket" />
                  Notify
                </a>
              </Popconfirm>
            ) : (
              <a onClick={() => handleNotify(row.id)}>
                <Icon type="rocket" />
                Notify
              </a>
            )}
          </li>
        ) : (
          <span>
            <Icon type="rocket" />
            Notify
          </span>
        )}
      </ul>
    );
  };

  const handleOnChangeHightlight = (row, e) => {
    if (typeof onChangeHighlightedItems !== 'undefined') {
      onChangeHighlightedItems(row.id, e.target.checked);
    }
  };

  const renderHighlight = (row) => {
    const now = new Date().setHours(0, 0, 0, 0) / 1000;

    const isOutDatePromo = row.end_date !== 0 && now > row.end_date;

    return (
      !isOutDatePromo && (
        <React.Fragment>
          <Checkbox
            checked={(highlightedItems || []).indexOf(row.id) >= 0}
            onChange={(e) => handleOnChangeHightlight(row, e)}
          />
        </React.Fragment>
      )
    );
  };

  const renderDate = (utime) => {
    if (utime !== 0) {
      const t = moment.unix(utime);
      return t.format('ll');
    }
    return '';
  };

  const checkPromoValidDate = (endDate) => {
    if (endDate !== 0 && moment.unix(endDate).format('L') < moment().format('L')) {
      return false;
    }
    return true;
  };

  const renderDescription = (row) => {
    const cleanHtml = DOMPurify.sanitize(row);
    return (
      <div
        style={{
          maxHeight: 400,
          maxWidth: 400,
          overflow: 'auto',
          fontSize: 12,
          lineHeight: 1.4,
          wordBreak: 'break-word',
        }}
        dangerouslySetInnerHTML={{ __html: cleanHtml }}
      />
    );
  };

  return (
    <Table
      bordered
      loading={loading}
      className={styles.Table}
      rowKey={(record) => record.id}
      dataSource={state.promos}
      expandedRowRender={(row) => (
        <PromoProductsTable
          promo={row}
          products={row.products}
          deletePromoduct={deletePromoduct}
          fetchPromo={fetchPromo}
          searchProductKeyword={searchProductKeyword}
        />
      )}
    >
      <Column width="60px" title="ID" dataIndex="id" key="id" />
      <Column title="Title" dataIndex="title" key="title" />
      <Column title="Type" dataIndex="type" key="type" />
      <Column
        width="200px"
        title="Description"
        dataIndex="description"
        key="description"
        render={(row) => renderDescription(row)}
      />
      <Column
        title="Date Range"
        width="120px"
        key="start_date"
        render={(row) => (
          <div style={{ textAlign: 'center' }}>
            {renderDate(row.start_date)}
            <br />-<br />
            {renderDate(row.end_date)}
          </div>
        )}
      />
      <Column
        title="Image"
        dataIndex="image_url"
        width="200px"
        key="image_url"
        render={(url) =>
          url === 'https:///' || url === '' ? <span>No image</span> : <img alt="Promo banner" width="200" src={url} />
        }
      />
      <Column title="Action" key="action" width="100px" render={(row) => renderActions(row)} />
      <Column title="Highlight" key="highlight" width="100px" render={(row) => renderHighlight(row)} />
    </Table>
  );
};

export default withRouter(PromosTable);



// WEBPACK FOOTER //
// ./src/components/Promo/PromosTable.js